// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1PUeE","header":"PatientBlock_header__cGl04","label":"PatientBlock_label__Jlbho","option":"PatientBlock_option__b57lT"};